import axios from 'axios';
import { Building } from 'app/edozvola/cases/construction-building-procedure/buildings/model/building.model';
import { Construction } from 'app/edozvola/cases/construction-building-procedure/constructions/model/construction.model';
import { Intervention } from 'app/edozvola/cases/construction-building-procedure/interventions/model/intervention.model';
import { ConstructionBuildingProcedure } from 'app/edozvola/cases/construction-building-procedure/model/construction-building-procedure.model';

export const fetchBuildings = async (idCase: string, page: number, size: number, column: string, direction: string): Promise<any> => {
  if (idCase) {
    return await new Promise(resolve => {
      axios
        .get(`api/construction-building-procedure/${idCase}/buildings?page=${page}&size=${size}&column=${column}&direction=${direction}`)
        .then(response => resolve(response.data));
    });
  }
};

export const fetchConstructionBuildingProcedureCodebooks = async (idCase: string): Promise<ConstructionBuildingProcedure> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/construction-building-procedure/${idCase}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const saveConstructionBuildingProcedureCodebooks = async (idCase: string, cbp: ConstructionBuildingProcedure): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/construction-building-procedure/${idCase}`, cbp)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const fetchBuilding = async (idBuilding: string, variant: string): Promise<Building> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/construction-building-procedure/buildings/${idBuilding}&${variant}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const saveBuilding = async (idBuilding: string, variant: string, building: Building): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/construction-building-procedure/buildings/${idBuilding}&${variant}`, building)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const deleteBuilding = async (idBuilding: number, variant: string): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .delete(`api/construction-building-procedure/buildings/${idBuilding}&${variant}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const copyBuilding = async (idBuilding: number, variant: string): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/construction-building-procedure/buildings/copy/${idBuilding}&${variant}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const fetchConstructions = async (idCase: string, page: number, size: number, column: string, direction: string): Promise<any> => {
  if (idCase) {
    return await new Promise(resolve => {
      axios
        .get(
          `api/construction-building-procedure/${idCase}/constructions?page=${page}&size=${size}&column=${column}&direction=${direction}`,
        )
        .then(response => resolve(response.data));
    });
  }
};

export const fetchConstruction = async (idConstruction: string, variant: string): Promise<Construction> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/construction-building-procedure/constructions/${idConstruction}&${variant}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const saveConstruction = async (idConstruction: string, variant: string, construction: Construction): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/construction-building-procedure/constructions/${idConstruction}&${variant}`, construction)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const deleteConstruction = async (idConstruction: number, variant: string): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .delete(`api/construction-building-procedure/constructions/${idConstruction}&${variant}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const copyConstruction = async (idConstruction: number, variant: string): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/construction-building-procedure/constructions/copy/${idConstruction}&${variant}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const fetchInterventions = async (idCase: string, page: number, size: number, column: string, direction: string): Promise<any> => {
  if (idCase) {
    return await new Promise(resolve => {
      axios
        .get(
          `api/construction-building-procedure/${idCase}/interventions?page=${page}&size=${size}&column=${column}&direction=${direction}`,
        )
        .then(response => resolve(response.data));
    });
  }
};

export const fetchIntervention = async (idIntervention: string, variant: string): Promise<Intervention> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/construction-building-procedure/interventions/${idIntervention}&${variant}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const saveIntervention = async (idIntervention: string, variant: string, intervention: Intervention): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/construction-building-procedure/interventions/${idIntervention}&${variant}`, intervention)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const deleteIntervention = async (idIntervention: number, variant: string): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .delete(`api/construction-building-procedure/interventions/${idIntervention}&${variant}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const copyIntervention = async (idIntervention: number, variant: string): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/construction-building-procedure/interventions/copy/${idIntervention}&${variant}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const copyBuildings = async (caseUuid: string, variant: string, caseWebIdToCopyFrom: string): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/construction-building-procedure/buildings/copy/${caseUuid}/${caseWebIdToCopyFrom}&${variant}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const copyConstructions = async (caseUuid: string, variant: string, caseWebIdToCopyFrom: string): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/construction-building-procedure/constructions/copy/${caseUuid}/${caseWebIdToCopyFrom}&${variant}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const copyInterventions = async (caseUuid: string, variant: string, caseWebIdToCopyFrom: string): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/construction-building-procedure/interventions/copy/${caseUuid}/${caseWebIdToCopyFrom}&${variant}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const getConstructionBuildingProcedureVariant = async (caseUuid: string, caseInPreview: boolean): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/${caseUuid}/construction-building-procedure-variant?caseInPreview=${caseInPreview}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};
